import firebase from 'firebase/compat/app';
import _firestore from '@google-cloud/firestore';
import { BaseRepository } from '../base/repository';
import { PredefinedInputField } from './model';

export class PredefinedInputFieldRepository extends BaseRepository<PredefinedInputField> {
  constructor(firestore: firebase.firestore.Firestore | _firestore.Firestore) {
    super(firestore, 'predefined_input_fields');
  }
}
